import TransactionByGatway from "./TransactionByGatway";
import { Tab, Tabs } from "react-bootstrap";
import FailedTransactions from "./FailedTransactions";
import ReasonFailedTransactions from "./ReasonFailedTransactions";
import DownloadInvoiceReport from "modules/invoiceCreditNotes/DownloadInvoiceReport";

function PayementGateway() {
  return (
    <>
      <Tabs defaultActiveKey="numberOfPyaments" id="uncontrolled-tab-example">
        <Tab
          eventKey="numberOfPyaments"
          title="Number Of Payments by Gateway"
          className="border-bottom border-x p-3"
        >
          <div
            className="d-flex gap-2"
            style={{ width: "70rem", alignItems: "center" }}
          ></div>
          <TransactionByGatway />
        </Tab>
        <Tab
          eventKey="Failure"
          title="Failure rate for Gateway"
          className="border-bottom border-x p-3"
        >
          <FailedTransactions />
        </Tab>
        <Tab
          eventKey="Reasons"
          title="Reasons for Payment failure"
          className="border-bottom border-x p-3"
        >
          <ReasonFailedTransactions />
        </Tab>
        <Tab
          eventKey="Download"
          title="Download"
          className="border-bottom border-x p-3"
        >
          <DownloadInvoiceReport source={"paymentGateway"}/>
        </Tab>
      </Tabs>
    </>
  );
}

export default PayementGateway;
